import Seo from "@/components/Seo";
import { PageHeader } from "@/components/Bits";
import { CONTACT } from "@/data/catalog";

function Row({ label, children }) {
  return (
    <div className="grid grid-cols-1 border-b border-r border-border sm:grid-cols-[270px_1fr]">
      <span className="mono-label border-b border-border p-4 text-muted-foreground sm:border-b-0 sm:border-r">{label}</span>
      <span className="p-4 font-body text-foreground">{children}</span>
    </div>
  );
}

export default function Impressum() {
  return (
    <>
      <Seo
        title="Impressum"
        description="Impressum und Offenlegung gemäß § 5 ECG der IMPEXMILTRADE GMBH, Hauptplatz 36, A-8480 Mureck."
      />
      <PageHeader
        code="RECHTLICH / § 5 ECG"
        title="Impressum"
        sub="Offenlegung und Angaben gemäß § 5 E-Commerce-Gesetz (ECG) sowie § 25 Mediengesetz."
      />

      <section className="mx-auto max-w-4xl px-5 py-16" data-testid="impressum-content">
        <div className="border-l border-t border-border">
          <Row label="Firma">Impexmiltrade GmbH</Row>
          <Row label="Anschrift">
            Hauptplatz 36
            <br />
            8480 Mureck
            <br />
            Österreich
          </Row>
          <Row label="Unternehmensgegenstand">Waffenhandel</Row>
          <Row label="Telefon">
            <a href={`tel:${CONTACT.phoneHref}`} className="hover:text-primary" data-testid="impressum-phone">
              {CONTACT.phone}
            </a>
          </Row>
          <Row label="Fax">{CONTACT.fax}</Row>
          <Row label="E-Mail">
            <a href={`mailto:${CONTACT.email}`} className="hover:text-primary" data-testid="impressum-email">
              {CONTACT.email}
            </a>
          </Row>
          <Row label="Internet">http://www.impexmiltrade.com</Row>
          <Row label="UID">ATU68282823</Row>
          <Row label="Firmenbuchnummer">FN 404926f</Row>
          <Row label="Firmenbuchgericht">Landesgericht Graz</Row>
          <Row label="Geschäftsführung">
            Jutta Rudolf
            <br />
            Armin Rudolf
          </Row>
          <Row label="Bankverbindung">
            Raiffeisenbank Mureck
            <br />
            SWIFT (BIC): RZSTAT2G370
            <br />
            IBAN: AT16 3837 0000 0303 9062
          </Row>
          <Row label="Inhaltlich verantwortlich">Armin Rudolf (gemäß § 10 Abs. 3 MDStV)</Row>
        </div>

        <div className="mt-10 space-y-8">
          <div>
            <h2 className="font-display text-xl font-600 uppercase tracking-tight text-foreground">Haftungshinweis</h2>
            <p className="mt-3 font-body text-sm text-muted-foreground">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </div>
          <div>
            <h2 className="font-display text-xl font-600 uppercase tracking-tight text-foreground">Google Analytics</h2>
            <p className="mt-3 font-body text-sm text-muted-foreground">
              Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc., um eine
              Analyse der Benutzung der Website zu ermöglichen. Die durch den Einsatz von Google Analytics
              erzeugten Informationen über Ihre Nutzung dieser Website (einschließlich Ihrer IP-Adresse)
              werden an einen Server der Google Inc. in den USA übertragen und dort gespeichert. Google wird
              diese Informationen lediglich dazu verwenden, die Nutzung der Website zu analysieren, indem
              anonymisierte Auswertungen und Grafiken zur Anzahl der Besuche, Anzahl der pro Nutzer
              aufgerufenen Seiten usw. erstellt werden. Diese setzen wir ausschließlich zu Zwecken der
              eigenen Marktforschung und vor allem der Optimierung und bedarfsgerechten Gestaltung unserer
              Webseiten ein. Mehr Informationen zur von Google eingesetzten Technologie finden Sie unter
              www.google.com/analytics.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
